module.exports = __webpack_public_path__ + "img/tutorial-04.9cfd0385.svg";